module.exports = __webpack_public_path__ + "img/bottom_ercode2.a5ee1b38.png";